import React, { Fragment, useState, useEffect, useContext } from "react";
import axios from "axios";
import { mm_rrrr_to_date } from '../../../../functions/dataFormat.js';
import { przypomnienieTrescMail, przypomnienieTrescSms, wezwanieTrescMail, wezwanieTrescSms } from '../../../../functions/zaleglosci.js';
import { zl, formatKonta, zaokr } from "../../../../functions/utilities.js";
import { AdresPro2 } from "../../../../functions/ulice.js";
import WspolnotaRozliczenieZaleglosciFiltr from "./WspolnotaRozliczenieZaleglosciFiltr.js";
import WspolnotaRozliczenieZaleglosciTHead from "./WspolnotaRozliczenieZaleglosciTHead.js";
import WspolnotaRozliczenieZaleglosciTBody from "./WspolnotaRozliczenieZaleglosciTBody.js";
import WspolnotaRozliczenieZaleglosciButtonWyslij from "./WspolnotaRozliczenieZaleglosciButtonWyslij.js";
import WspolnotaRozliczenieSMS from "./WspolnotaRozliczenieSMS.js";
import Loader from "../../../Loader.js";
import { AuthContext } from "../../../../Context/AuthProvider.js";
import { zamienPolskieZnaki } from "../../../../functions/dictionary.js";

const WspolnotaRozliczenieZaleglosci = (props) => {

  const { wspolnota, udzialyKontaAkt, przelewyWspolnota, czynszeWspolnota, mieszkancy, ulice, lokale, grupy, idw, zaleglosciPowiadomienia } = props;

  const {user } = useContext(AuthContext);
  
  const [przelewySuma, setPrzelewySuma] = useState(undefined);
  const [czynszeSuma, setCzynszeSuma] = useState(0);
  const [wybranyFiltr, setWybranyFiltr] = useState('1');
  const [tablica, setTablica] = useState(undefined);
  const [loaderOn, setLoaderOn] = useState(true);
  const [stanKonta, setStanKonta] = useState(0);
  const [allSms, setAllSms] = useState(true);
  const [allEmail, setAllEmail] = useState(true);

  const [liczbaDostepnychSms, setLiczbaDostepnychSms] = useState(undefined);
  const [liczbaPotrzebnychSms, setLiczbaPotrzebnychSms] = useState(undefined);

  const [ileSms, setIleSms] = useState(undefined);

  const handleStanKonta = async () => {
    try {
      const response = await axios.get('/api/stan-konta'); // <-- zapytanie do backendu
      setStanKonta( response.data.points )
      setLiczbaDostepnychSms( zaokr(response.data.points / 0.17, 2) )
    } catch (error) {
      console.error('Błąd pobierania stanu konta:', error);
    }
  }

  useEffect( () => {
    handleStanKonta();
  },[]);

  useEffect( () => {
    const temp = przelewyWspolnota.map(({ id_user, nr_grupyUdzial, przelewy }) => ({
      id_user,
      grupa_numer: nr_grupyUdzial,
      suma: Math.round( przelewy.reduce((acc, { kwota }) => acc + kwota, 0) * 100 ) / 100 , // Sumowanie kwot
    }));
    setPrzelewySuma(temp);
  },[przelewyWspolnota])

  useEffect( () => {  
    const currentDate = new Date();
    const temp = czynszeWspolnota.flatMap(({ grupy_udzial_msc }) => 
      grupy_udzial_msc.map(({ grupa_numer, id_user, temp_msc }, i) => {
        const mieszkaniec = mieszkancy?.find( m => m?.id_user == id_user);
        const validTempMsc = temp_msc.filter(({ msc }) => new Date(mm_rrrr_to_date(msc)) <= currentDate);
        const suma = Math.round( validTempMsc.reduce((acc, { czynsz_na_msc }) => acc + czynsz_na_msc, 0) * 100 )/ 100;
        const ostatniCzynsz = [...validTempMsc]
          .filter(({ czynsz_na_msc }) => czynsz_na_msc > 0) // Pomijamy wpisy z czynszem 0
          .sort((a, b) => new Date(mm_rrrr_to_date(b.msc)) - new Date(mm_rrrr_to_date(a.msc))) // Sortujemy malejąco po dacie
          .shift() || null; // Pobieramy pierwszy element lub null jeśli brak

        const dwukrotnoscOstatniegoCzynszu = ostatniCzynsz?.czynsz_na_msc * 2;
        
        return { id: i, grupa_numer, id_user,suma, ostatniCzynsz, dwukrotnoscOstatniegoCzynszu, mieszkaniec  /* suma, /*, ostatniObiekt*/ };
      })
    );
    setCzynszeSuma(temp)
  },[czynszeWspolnota, mieszkancy]);

  useEffect( () => {

    const temp = czynszeSuma && czynszeSuma?.map( (czynsz, i) => {

      const przelew = przelewySuma?.find( p => p?.id_user == czynsz?.id_user && p?.grupa_numer == czynsz?.grupa_numer);
      const przelewySuma_g = przelew ? przelew.suma : 0;
      const saldo = przelewySuma_g - czynsz?.suma;
      const udzial = udzialyKontaAkt?.find( u => u?.id_user == czynsz?.id_user && u?.grupa_numer == czynsz?.grupa_numer)
      const adres = AdresPro2(udzial, lokale, ulice, grupy);
      const zalegloscTxT = zl( (przelewySuma_g - czynsz?.suma) * -1 );
      const telefon = czynsz?.mieszkaniec?.telefon;
      const email = czynsz?.mieszkaniec?.email;

      let saldoStopien, rodzajPowiadomienia;

      if (saldo <= czynsz?.dwukrotnoscOstatniegoCzynszu * -1) {
        saldoStopien = 2;
        rodzajPowiadomienia = "Wezwanie";
      } else if ( saldo <= czynsz?.ostatniCzynsz?.czynsz_na_msc * -1 && saldo > czynsz?.dwukrotnoscOstatniegoCzynszu * -1) {
        saldoStopien = 1;
        rodzajPowiadomienia = "Przypomnienie"
      } else if (saldo < 0) {
        saldoStopien = 0;
      }

      let trescMail, trescSms;
      
      switch (wybranyFiltr) {
        case '1': 
          trescMail = przypomnienieTrescMail(zalegloscTxT, formatKonta(udzial.konto_bankowe), wspolnota.name);
          trescSms = zamienPolskieZnaki(przypomnienieTrescSms(zalegloscTxT, formatKonta(udzial.konto_bankowe), wspolnota.name));
          break;
        case '2':
          trescMail = wezwanieTrescMail(zalegloscTxT, formatKonta(udzial.konto_bankowe), wspolnota.name);
          trescSms = zamienPolskieZnaki(wezwanieTrescSms(zalegloscTxT, formatKonta(udzial.konto_bankowe), wspolnota.name));
          break;
        default: 
          trescMail = "brak";
          trescSms = "brak";
          break;
      }
      
      const liczbaSms = Math.ceil(trescSms.length / 160);

      return ({
        id: i,
        mieszkaniec: `${czynsz?.mieszkaniec?.imie_nazwisko} (${czynsz?.mieszkaniec?.id_user})`,
        telefon,
        email,
        adres,
        czynsz,
        udzial,
        przelewySuma_g,
        saldo,
        saldoPlus: saldo * -1,
        saldoStopien,
        rodzajPowiadomienia,
        trescMail,
        trescSms,
        zalegloscTxT,
        liczbaSms,
        czyWyslacSms: false,
        czyWyslacEmail: false
      })
    })?.filter( c => c?.saldoStopien == wybranyFiltr);
    
    setTablica(temp);
  }, [czynszeSuma, przelewySuma, udzialyKontaAkt, wybranyFiltr]);


  const handleCheckSms = id => {
    setTablica( prevState => 
      prevState.map( obj => 
        obj.id == id ? { ...obj, czyWyslacSms: !obj.czyWyslacSms } : obj
      )
    );
  };

  const handleCheckEmail = id => {
    setTablica( prevState => 
      prevState.map( obj => 
        obj.id == id ? { ...obj, czyWyslacEmail: !obj.czyWyslacEmail } : obj
      )
    );
  }; 

  const handleCheckAllSms = () => {
    setTablica( prevState => 
      prevState.map( obj => ({
        ...obj,
        czyWyslacSms: allSms
      }))
    );
    setAllSms( prevState => !prevState);
  }

  const handleCheckAllEmail = () => {
    setTablica( prevState => 
      prevState.map( obj => ({
        ...obj,
        czyWyslacEmail: allEmail
      }))
    )
    setAllEmail( prevState => !prevState);
  }

  useEffect( () => tablica && zaleglosciPowiadomienia && liczbaDostepnychSms ? setLoaderOn(false) : setLoaderOn(true), [tablica, zaleglosciPowiadomienia, liczbaDostepnychSms]);

  useEffect( () => {
    const temp = tablica && tablica.reduce((acc, obj) => obj.czyWyslacSms === true ? acc + obj.liczbaSms : acc + 0, 0);
    setLiczbaPotrzebnychSms(temp );
  },[tablica, stanKonta]);

  useEffect( () => {
    if (tablica && tablica?.length > 0)
      setIleSms( tablica?.filter( t => t?.czyWyslacSms === true).length );
  }, [tablica])

  return (
    <Fragment>  
      { user === "kkr_" ? <WspolnotaRozliczenieSMS /> : <Fragment></Fragment> }

      <div className="panel-zaleglosci">
        <WspolnotaRozliczenieZaleglosciFiltr
          wybranyFiltr={wybranyFiltr}
          setWybranyFiltr={setWybranyFiltr}
          user={user}
        />
        <WspolnotaRozliczenieZaleglosciButtonWyslij
          wspolnota={wspolnota}
          tablica={tablica}
          setTablica={setTablica}
          idw={idw}
          user={user}
          ileSms={ileSms}
          wybranyFiltr={wybranyFiltr}
        />
        <div className="stats">
          <p>{`Stan konta SMS API: ${stanKonta}`}</p>
          { liczbaDostepnychSms - liczbaPotrzebnychSms < 0 ? <p style={{fontWeight: "600"}}>Stan konta zbyt niski, by wysłac SMSy</p> : <p>{`Liczba dostępnych / potrzebnych SMS: ${liczbaDostepnychSms} / ${liczbaPotrzebnychSms}`}</p> }
          
        </div>
      </div>
      <div className="table-container">
        <table 
          className="tabela naleznosci" 
          style={{width: "fit-content"}}
        > 
          <WspolnotaRozliczenieZaleglosciTHead
            handleCheckAllSms={handleCheckAllSms}
            handleCheckAllEmail={handleCheckAllEmail}
          />
          <WspolnotaRozliczenieZaleglosciTBody
            tablica={tablica}
            mieszkancy={mieszkancy}
            handleCheckSms={handleCheckSms}
            handleCheckEmail={handleCheckEmail}
            user={user}
            zaleglosciPowiadomienia={zaleglosciPowiadomienia}
          />
        </table>
      </div>

      <Loader stan={loaderOn} />
    </Fragment>
  )
}

export default WspolnotaRozliczenieZaleglosci;